module.exports = __webpack_public_path__ + "static/img/img9.6893267c.png";